import { handleFetchResponse, requestWithTimeout } from '@noths/polaris-client-utils';
import { Product } from '@noths/polaris-dev-ts-types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import getConfig from 'next/config';

import { NextConfig } from 'src/types';

const { publicRuntimeConfig } = getConfig() as NextConfig;

interface RequestFeaturedProductArguments {
  code: number;
}

export interface RequestFeaturedProductAPIResponse {
  product: Product;
}

export const requestFeaturedProduct = createAsyncThunk<Product, RequestFeaturedProductArguments>(
  'products/featuredProduct',
  async ({ code }) => {
    const apiResponse = await requestWithTimeout({
      apiEndpoint: publicRuntimeConfig.endpoints.catalogueMesh,
      apiPath: `v1/product-details?code=${code}`,
    });

    const { product }: RequestFeaturedProductAPIResponse = await handleFetchResponse(
      apiResponse as Response,
    );

    return product;
  },
);
